import alt from '../alt';
export default alt.createActions({
  init: snapshot => snapshot,
});



// WEBPACK FOOTER //
// ./src/actions/PageAction.js